export const getProjectCreateHttpStatus = (error: unknown): number | null => {
  const candidate = error as {
    code?: unknown;
    status?: unknown;
    response?: {
      code?: unknown;
      status?: unknown;
      data?: { code?: unknown };
    };
  } | null;
  const status = [
    candidate?.response?.data?.code,
    candidate?.response?.code,
    candidate?.code,
    candidate?.response?.status,
    candidate?.status,
  ]
    .map((value) => Number(value))
    .find((value) => Number.isInteger(value) && value >= 100 && value <= 599);
  return status ?? null;
};
